/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import qs from 'qs';
import _ from 'lodash';

Vue.use(Vuex);

const type = {
  APP_INITIALIZED: 'APP_INITIALIZED',
  GET_PARTS_DATA: 'GET_PARTS_DATA',
  GET_PAGES_DATA: 'GET_PAGES_DATA',
  ADD_PART: 'ADD_PART',
  REMOVE_PART: 'REMOVE_PART',
  RESET_CONFIGURATION: 'RESET_CONFIGURATION',
  UPDATE_IMAGES: 'UPDATE_IMAGES',
  TOGGLE_SETUP: 'TOGGLE_SETUP',
  HIDE_SETUP: 'HIDE_SETUP',
  SET_MARKET: 'SET_MARKET',
  SET_DARK: 'SET_DARK',
};

const state = {
  initialized: false,
  parts: [],
  initialConfiguration: [],
  configuration: [],
  images: [],
  setupVisible: false,
  spec: [],
  markets: {},
  pages: {},
  dark: false,
  selectedMarket: 'education',
};

const actions = {
  initialize({ commit }) {
    commit(type.APP_INITIALIZED);
  },
  async getAppData({ commit, dispatch, state }) {
    const parts = await axios.get('static/data/parts.json');
    commit(type.GET_PARTS_DATA, parts.data);

    const pages = await axios.get('static/data/pages.json');
    commit(type.GET_PAGES_DATA, pages.data);

    state.initialConfiguration.forEach((partId) => {
      dispatch('addPart', partId);
    });

    commit(type.UPDATE_IMAGES);
  },
  addIf({ state, dispatch }) {
    state.parts.forEach((part) => {
      if (part.add_if) {
        part.add_if.forEach((configuration) => {
          if (_.difference(configuration, state.configuration).length === 0) {
            dispatch('addPart', part.id);
          }
        });
      }
    });
  },
  addPart({ commit, state, dispatch }, partId) {
    if (state.configuration.indexOf(partId) !== -1) return;

    const partToAdd = state.parts.find(part => part.id === partId);
    commit(type.ADD_PART, partId);
    dispatch('addIf');

    partToAdd.requires.forEach((requiredPartList) => {
      let shouldAdd = true;
      requiredPartList.forEach((requiredPart) => {
        if (state.configuration.indexOf(requiredPart) > -1) {
          shouldAdd = false;
        }
      });
      if (shouldAdd) {
        dispatch('addPart', requiredPartList[0]);
      }
    });

    commit(type.UPDATE_IMAGES);
  },
  removePart({ commit, state, dispatch }, partId) {
    if (state.configuration.indexOf(partId) === -1) return;

    const partToRemove = state.parts.find(part => part.id === partId);
    if (state.configuration.indexOf(partToRemove.remove_first) !== -1) {
      dispatch('removePart', partToRemove.remove_first);
      return;
    }

    commit(type.REMOVE_PART, partId);

    state.parts.forEach((part) => {
      part.requires.forEach((requiredPartList) => {
        let shouldRemove = true;
        requiredPartList.forEach((requiredPart) => {
          if (state.configuration.indexOf(requiredPart) > -1) {
            shouldRemove = false;
          }
        });
        if (shouldRemove) {
          dispatch('removePart', part.id);
        }
      });
    });

    commit(type.UPDATE_IMAGES);
  },
  resetConfiguration({ commit, state, dispatch }) {
    commit(type.RESET_CONFIGURATION);

    state.initialConfiguration.forEach((partId) => {
      dispatch('addPart', partId);
    });
  },
  toggleSetup({ commit }) {
    commit(type.TOGGLE_SETUP);
  },
  hideSetup({ commit }) {
    commit(type.HIDE_SETUP);
  },
  setMarket({ commit }, value) {
    commit(type.SET_MARKET, value);
  },
  setDark({ commit }, value) {
    commit(type.SET_DARK, value);
  },
  formSubmit({ state }, formData) {
    const partsData = state.parts
      .reduce((sum, part) => {
        const tempSum = sum;
        tempSum[part.pardot_id] = tempSum[part.pardot_id] || 0;

        for (let i = 0; i < state.configuration.length; i += 1) {
          if (state.configuration[i] === part.id) {
            tempSum[part.pardot_id] += 1;
          }
        }

        return tempSum;
      }, {});

    const specData = state.spec
      .filter(spec => spec.pardot_id)
      .reduce((sum, spec) => {
        const tempSum = sum;
        let val = spec.value;
        if (Array.isArray(spec.value)) {
          val = spec.value.reduce((valSum, valItem, index) => {
            let tempValSum = valSum;
            if (index) {
              tempValSum += '<br/>';
            }
            tempValSum += `- ${valItem.name}: ${valItem.value}`;
            return tempValSum;
          }, '');
        }
        tempSum[spec.pardot_id] = val;
        return tempSum;
      }, {});
    const data = { ...partsData, ...formData, ...specData };

    return axios.post('http://ibrochureskyocera.chyzo.com/post-wrapper.php', qs.stringify(data))
      .then(response => response.data.success)
      .catch(() => false);
  },
};

const mutations = {
  [type.APP_INITIALIZED](state) {
    state.initialized = true;
  },
  [type.GET_PARTS_DATA](state, { parts, initialConfiguration, spec }) {
    state.parts = parts;
    state.initialConfiguration = initialConfiguration;
    state.spec = spec;
  },
  [type.GET_PAGES_DATA](state, { pages, markets }) {
    state.markets = markets;
    state.pages = pages;
  },
  [type.ADD_PART](state, partId) {
    if (state.configuration.indexOf(partId) === -1) {
      state.configuration.push(partId);
    }
  },
  [type.UPDATE_IMAGES](state) {
    const images = [];
    for (let i = 0; i < state.configuration.length; i += 1) {
      const part = state.parts.find(element => element.id === state.configuration[i]);
      let image = null;
      part.images.forEach((element) => {
        if (_.difference(element.configuration, state.configuration).length === 0) {
          image = element;
        }
      });

      if (image) {
        images.push(image);
      }
    }
    state.images = _.sortBy(images, ['order']);
  },
  [type.REMOVE_PART](state, partId) {
    state.configuration.splice(state.configuration.indexOf(partId), 1);
  },
  [type.RESET_CONFIGURATION](state) {
    state.configuration = [];
    state.images = [];
  },
  [type.TOGGLE_SETUP](state) {
    state.setupVisible = !state.setupVisible;
  },
  [type.HIDE_SETUP](state) {
    state.setupVisible = false;
  },
  [type.SET_MARKET](state, market) {
    state.selectedMarket = market;
  },
  [type.SET_DARK](state, value) {
    state.dark = value;
  },
};

const getters = {
  benefits({ selectedMarket, markets, pages }) {
    if (!pages) {
      return {};
    }

    if (selectedMarket) {
      const marketBenefits = markets[selectedMarket].benefits;
      return Object.keys(pages.benefits)
        .filter(key => marketBenefits.includes(key))
        .reduce((array, key) => {
          const tempArr = array;
          tempArr[key] = pages.benefits[key];
          return tempArr;
        }, {});
    }

    return pages.benefits;
  },
  isDark({ dark, route }) {
    return route.name === 'Benefits' && dark;
  },
};

export default new Vuex.Store({
  state,
  actions,
  getters,
  mutations,
});



// WEBPACK FOOTER //
// ./src/store/index.js